import { render, staticRenderFns } from "./bsp-dicts-city.vue?vue&type=template&id=7174afcb&scoped=true&"
import script from "./bsp-dicts-city.vue?vue&type=script&lang=js&"
export * from "./bsp-dicts-city.vue?vue&type=script&lang=js&"
import style0 from "./bsp-dicts-city.vue?vue&type=style&index=0&id=7174afcb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7174afcb",
  null
  
)

export default component.exports